import React, { useEffect, useState, ChangeEvent } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  TextField,
} from '@mui/material';
import { CustomAxios as axios } from '../../common/axios';

import type { SelectLineStationType } from '../pages/Home';
import type { CalcSettingType } from '../../types/calc/calc';

type ReportModalType = {
  dispReportModal: boolean;
  setDispReportModal: React.Dispatch<React.SetStateAction<boolean>>;
  calcSetting: CalcSettingType;
  route: SelectLineStationType[];
  result: string;
};

type RequestData = {
  incorrectFare?: number;
  calcSetting?: string;
  route?: string;
  result?: string;
  correctFare?: string;
  detail?: string;
};

export const ReportModal = ({
  dispReportModal: dispSettingModal,
  setDispReportModal,
  calcSetting,
  route,
  result,
}: ReportModalType) => {
  const [requestData, setRequestData] = useState<RequestData>({});

  useEffect(() => {
    const s = JSON.stringify(calcSetting);
    const r = JSON.stringify(route);
    setRequestData((prev) => ({
      ...prev,
      calcSetting: s,
      route: r,
      result,
    }));
  }, [calcSetting, route]);

  /** 計算設定を閉じる */
  const closeModal = () => {
    setDispReportModal(false);
  };

  const inputChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setRequestData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendReport = async () => {
    try {
      const response = await axios
        .post(`/report/fare`, { ...requestData })
        .then(() => {
          window.alert('報告が完了しました\n(ご協力ありがとうございます！)');
        });
    } catch (err) {
      window.alert('予期せぬエラーが発生しました。\n報告に失敗しました。');
      console.warn(err);
    } finally {
      closeModal();
    }
  };

  return (
    <Dialog open={dispSettingModal} disableEscapeKeyDown>
      <DialogTitle>計算設定</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>計算結果の誤りについて、詳細を記載してください。</p>
          <p>入力内容と計算結果は自動的に送信されます。</p>
          <p>※正しい運賃を記載いただけると非常に助かります！</p>
        </DialogContentText>
        <TextField
          label="正しい運賃"
          id="correct-fare"
          name="correctFare"
          sx={{ marginTop: '15px' }}
          fullWidth
          onChange={inputChangeHandler}
        />
        <TextField
          label="詳細"
          id="report-detail"
          name="detail"
          multiline
          rows={4}
          sx={{ marginTop: '15px' }}
          fullWidth
          onChange={inputChangeHandler}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={closeModal}>戻る</Button>
        <Button onClick={sendReport} variant="outlined" color="primary">
          報告
        </Button>
      </DialogActions>
    </Dialog>
  );
};
